import React from "react"
import {BundleType, ProductType, SofaType, SuitType} from "../../../../config/constants"
import connect from "./connect"
import {useProductLazyLoadImage} from "../../../../hooks/useLazyLoadImage"
import {TileImageComponent} from "./components"

export interface TileImageProps {
    imageUrl: string
    alt: string
    testid: string
    imageRatio: string
    productType: typeof SuitType | typeof ProductType | typeof SofaType | typeof BundleType
}

export const TileImage = ({imageUrl, alt, testid, imageRatio, productType}: TileImageProps) => {
    const imageProps = useProductLazyLoadImage(imageUrl)
    const [src, setSrc] = React.useState(imageUrl)
    const getFallbackUrl = (url: string) => {
        // This regex finds and captures the dynamic segment before "/bundle"
        // and replaces "bundle" with "search", preserving the dynamic part.
        const updatedUrl = url.replace(/\/([^/]+)\/Bundle/, "/$1/Search")
        // You can then chain your original filename-cleaning logic
        return updatedUrl.replace(/\/([^/]+?)(_[^/]+)?(\.jpg.*)/, (_match, filename, _suffix, ext) => {
            return `/${filename}${ext}`
        })
    }
    const conditionalProps = productType === "bundle" ? {onError: () => setSrc(getFallbackUrl(imageUrl))} : {}

    return (
        <TileImageComponent
            {...imageProps}
            src={src}
            // alt={alt}
            data-testid={testid}
            imageRatio={imageRatio}
            {...conditionalProps}
        />
    )
}

export default connect(TileImage)
